export default defineNuxtRouteMiddleware((to, from) => {
  // skip middleware on server
  if (import.meta.server) return

  const utmQueries = Object.keys(from.query).filter((key) =>
    key.includes('utm')
  )
  const hasToAnUtmQuery = Object.keys(to.query).some((key) =>
    key.includes('utm')
  )

  if (utmQueries.length !== 0 && !hasToAnUtmQuery) {
    const newTo = { ...to }
    for (const query of utmQueries) {
      if (from.query.hasOwnProperty(query) && !to.query.hasOwnProperty(query)) {
        newTo.query[query] = from.query[query]
      }
    }
    return newTo
  }

  if (from.query.hasOwnProperty('gclid') && !to.query.hasOwnProperty('gclid')) {
    const newTo = { ...to }
    newTo.query.gclid = from.query.gclid
    return newTo
  }

  return
})
